import { dataTeam } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTeam = /*#__PURE__*/createIcon(dataTeam)
export default IconTeam
